import { apiClient, getData, getPage, type Page } from '@/api/client'

/*
 * `apiClient` is typed against the generated schema's paths, so an endpoint mm-be has not
 * published yet cannot be named on it. This is the one seam for such a call: the same client, so
 * the same auth, request id, error middleware and session renewal, with the path as a plain string.
 *
 * Only for a service that sits behind its own `available = false` constant and has a proposed
 * contract written down in `asks/` (videos, brief, commodity prices, share unlocks, intraday
 * index). When mm-be ships an endpoint and `pnpm gen:api` knows the path, its service moves to
 * the typed `apiClient` call and drops out of this file's caller list.
 */
type Query = Record<string, string | number | boolean>

interface UntypedClient {
  GET: (
    path: string,
    init?: { params: { query: Query } },
  ) => Promise<{ data?: unknown; error?: unknown }>
  POST: (path: string, init: { body: unknown }) => Promise<{ data?: unknown; error?: unknown }>
  PATCH: (path: string, init: { body: unknown }) => Promise<{ data?: unknown; error?: unknown }>
}

const untyped = apiClient as unknown as UntypedClient

const init = (query?: Query) => (query === undefined ? undefined : { params: { query } })

/** A single-object (or bare-list) envelope, as `getData` unwraps it. */
export const proposedGet = <T>(path: string, query?: Query): Promise<T> =>
  getData<T>(() => untyped.GET(path, init(query)))

/** A paged list envelope, as `getPage` unwraps it. */
export const getProposedPage = <T>(path: string, query?: Query): Promise<Page<T>> =>
  getPage<T>(() => untyped.GET(path, init(query)))

export const proposedPost = <T>(path: string, body: unknown): Promise<T> =>
  getData<T>(() => untyped.POST(path, { body }))

/** rest:ab — a partial update (Account's notification and sign-in settings, asks AC5/AC6). */
export const proposedPatch = <T>(path: string, body: unknown): Promise<T> =>
  getData<T>(() => untyped.PATCH(path, { body }))
